import FooterBox from './footer';
import HeaderBox from './header';

export default function FKSWrap({
  isLogin,
  children,
  scrollToSection,
}: {
  isLogin: boolean
  children: React.ReactNode;
  scrollToSection: (section: string) => void;
}) {
  return (
    <div className='w-full'>
      <HeaderBox isLogin={isLogin} scrollToSection={scrollToSection} />
      <main className='w-full mt-[80px]'>{children}</main>
      <FooterBox />
    </div>
  );
}
